import { Notifier, type INotice } from '@airbrake/browser';

export default {
  notify,
};

let _notifier: Notifier | undefined;
function notify(notice: INotice | Error): void {
  if (!_notifier) {
    // A `projectId` and `projectKey` must be set for @airbrake/browser, but it proxies through our
    // backend (to prevent adblockers from blocking reporting) and real values are injected there
    _notifier = new Notifier({ host: '/airbrake', projectId: 1, projectKey: 'proxied' });
  }

  _notifier.notify(notice);
}
